export default "__VITE_ASSET__BsIXkKIa__"